export default {
  data() {
    return {
      loading: false,
      data: {}
    }
  },
  props: ['carNo','hiddenName'],

  created() {
    this.$watch('carNo' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = {}
      }
    },{immediate:true})
  },
  methods: {
    query() {
      this.loading = true
      this.$request.partnerCarInsurance(this.carNo).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = this.$utils.conv(resp.data , {'startDatetime':'datetime'})

        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render() {
    const data = this.data || {}

    return (
      <sl-detail-list col={1} label-width="130px" label-align="right" style="padding:12px;">
        <sl-detail-list-item title="保单号" content={data.insuranceNo} />
        <sl-detail-list-item title="保险生效" content={data.startDatetimeText} />
        <sl-detail-list-item title="保险公司" content={data.insuranceCompanyName} />
        <sl-detail-list-item title="保险产品" content={data.insuranceName} />
        <sl-detail-list-item title="产品须知" html={true} content={data.notice} />
      </sl-detail-list>
            
    )
  }
}
